// src/components/ui/PublicReplayHeader.js
import React from 'react';
import { Link } from 'react-router-dom'; // Use Link for internal app navigation

const PublicReplayHeader = () => {
    // Define app-specific auth paths (adjust if your routes are different)
    const loginPath = '/login';
    const signupPath = '/signup';
    // Define the root sales site URL for the logo link and feature links
    const salesSiteUrl = 'https://dualnback.com'; // Or your actual sales site URL

    return (
        // Use sticky, shadow, and background like the example
        <header className="bg-white shadow-md sticky top-0 z-50 w-full">
            <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex items-center">
                        {/* Logo - Adopt structure from example */}
                        <a href={salesSiteUrl} className="flex items-center" title="Home">
                            {/* Icon Box (using indigo theme) */}
                            <div className="h-10 w-10 mr-2 bg-gradient-to-br from-indigo-600 to-indigo-800 rounded-lg flex items-center justify-center shadow-sm">
                                <span className="font-tomorrow font-semibold text-xl text-white" style={{ fontFamily: 'Tomorrow, sans-serif', fontWeight: 600 }}>N²</span>
                            </div>
                             {/* Text + Beta Tag Box */}
                            <div /* Removed flex-col as parent a is already flex items-center */ >
                                <div className="flex items-center flex-wrap"> {/* Added flex-wrap */}
                                    <span className="font-tomorrow font-bold text-xl text-gray-800">Dual N-Back</span>
                                    {/* Added Beta Tag - styled like example */}
                                    <span
                                        className="ml-2 px-1.5 py-0.5 bg-gray-800 text-white text-xs font-semibold rounded-sm whitespace-nowrap"
                                        style={{ fontSize: '0.65rem', letterSpacing: '0.05em' }}
                                    >
                                        BETA
                                    </span>
                                </div>
                            </div>
                        </a>

                        {/* Desktop Navigation Links - Ensure href points to sales site */}
                        <div className="hidden md:flex md:ml-6 space-x-8">
                            <a href={`${salesSiteUrl}/#progression`} className="text-gray-600 hover:text-gray-900 hover:border-indigo-500 flex items-center h-16 border-b-2 border-transparent font-medium transition-colors">
                                Features
                            </a>
                            <a href={`${salesSiteUrl}/#analytics`} className="text-gray-600 hover:text-gray-900 hover:border-indigo-500 flex items-center h-16 border-b-2 border-transparent font-medium transition-colors">
                                Analytics
                            </a>
                            {/* Optional: Add other links from example if needed, pointing to sales site */}
                             <a href={`${salesSiteUrl}/#wmc-assessment`} className="text-gray-600 hover:text-gray-900 hover:border-indigo-500 flex items-center h-16 border-b-2 border-transparent font-medium transition-colors">
                                Measure
                            </a>
                            <a href={`${salesSiteUrl}/#journal`} className="text-gray-600 hover:text-gray-900 hover:border-indigo-500 flex items-center h-16 border-b-2 border-transparent font-medium transition-colors">
                                Journal
                            </a>
                            <a href={`${salesSiteUrl}/#social`} className="text-gray-600 hover:text-gray-900 hover:border-indigo-500 flex items-center h-16 border-b-2 border-transparent font-medium transition-colors">
                                Social
                            </a>
                        </div>
                    </div>
                    <div className="flex items-center space-x-2 sm:space-x-4"> {/* Adjusted spacing like example */}
                        {/* Login Button (use Link, keep indigo theme) */}
                        <Link
                            to={loginPath}
                            className="hidden sm:inline-flex items-center px-4 py-2 border border-indigo-600 text-indigo-600 text-sm font-medium rounded-md hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition"
                            // Adjusted padding like example
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                            </svg>
                            Login
                        </Link>

                        {/* Sign Up Button (use Link, keep indigo theme, fix wrapping) */}
                        <Link
                            to={signupPath}
                            className="inline-flex items-center whitespace-nowrap px-3 sm:px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition"
                            // Added whitespace-nowrap, adjusted padding like example
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor"> {/* Adjusted icon margin */}
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                            <span>Sign Up</span> {/* Changed text to "Sign Up", wrapped in span */}
                        </Link>

                        {/* Mobile menu button - Keep existing structure, functionality not added here */}
                        <button type="button" className="mobile-menu-button md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" aria-expanded="false">
                            <span className="sr-only">Open main menu</span>
                            <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </nav>
            {/* Mobile menu content div - Keep structure like example, but leave hidden as functionality is not implemented here */}
            <div className="mobile-menu md:hidden hidden bg-white border-t">
                <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                     <a href={`${salesSiteUrl}/#progression`} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100">Features</a>
                    <a href={`${salesSiteUrl}/#analytics`} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100">Analytics</a>
                    <a href={`${salesSiteUrl}/#wmc-assessment`} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100">Measure</a>
                    <a href={`${salesSiteUrl}/#journal`} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100">Journal</a>
                    <a href={`${salesSiteUrl}/#social`} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100">Social</a>
                    <Link to={loginPath} className="block px-3 py-2 mt-2 rounded-md text-base font-medium text-indigo-600 hover:bg-indigo-50">Login</Link> {/* Use Link for app login */}
                </div>
            </div>
        </header>
    );
};

export default PublicReplayHeader;